module.exports = __webpack_public_path__ + "static/video-hero-9a61123575be8e7c2b9291ad75e3b751.mp4";